import { dataHeartHandshakeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeartHandshakeSolid = /*#__PURE__*/createIcon(dataHeartHandshakeSolid)
export default IconHeartHandshakeSolid
